export default __webpack_public_path__ + "static/media/previousPriceWithText.60bc4602.svg";